export default __webpack_public_path__ + "static/co-production-collective-ee14d385af823113c1b4e0c58030b2e4.webp";